/* eslint-disable import/prefer-default-export */

export const loginEndpoint = state => `${state.config.apiUrl}/v1/auth/login`;
export const oktaLoginEndpoint = state => `${state.config.apiUrl}/v1/auth/login/employee`;

export const accountConfirmEndpoint = state => `${state.config.apiUrl}/v1/users/confirm`;
export const passwordResetEndpoint = state => `${state.config.apiUrl}/v1/users/password-reset`;

export const isLoggedIn = state => state.auth.loggedIn;
export const authToken = state => isLoggedIn(state) && state.auth.authToken;
export const authTokenLocalStorage = () => localStorage.getItem('authToken');

export const oktaToken = state => state.auth.oktaToken;



// WEBPACK FOOTER //
// ./src/services/auth/selectors.js